import dayjs from 'dayjs'
import { pattern } from '@/utils/pattern'

export function isObject (value) {
    return typeof value === 'object' && value !== null
}
/* 获取网址问号后面参数
* */
export function getRequest () {
    let url = location.search //获取url中"?"符后的字串
    let theRequest = new Object()
    if (url.indexOf('?') != -1) {
        let str = url.substr(1)
        let strs = str.split('&')
        for ( let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
        }
    }
    return theRequest
}

/**
 * 删除URL中指定search参数,会将参数值一起删除
 * @param {string} url 地址字符串
 * @param {array} aParam 要删除的参数key数组，如['name','age']
 * @return {string} 返回新URL字符串
 */
export function delUrlParam (url, aParam) {
    aParam.forEach(item => {
        const fromindex = url.indexOf(`${item}=`) //必须加=号，避免参数值中包含item字符串
        if (fromindex !== -1) {
            // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
            const startIndex = url.indexOf('=', fromindex)
            const endIndex = url.indexOf('&', fromindex)
            const hashIndex = url.indexOf('#', fromindex)

            let reg
            if (endIndex !== -1) { // 后面还有search参数的情况
                const num = endIndex - startIndex
                reg = new RegExp(`${item}=.{${num}}`)
                url = url.replace(reg, '')
            } else if (hashIndex !== -1) { // 有hash参数的情况
                const num = hashIndex - startIndex - 1
                reg = new RegExp(`&?${item}=.{${num}}`)
                url = url.replace(reg, '')
            } else { // search参数在最后或只有一个参数的情况
                reg = new RegExp(`&?${item}=.+`)
                url = url.replace(reg, '')
            }
        }
    })
    const noSearchParam = url.indexOf('=')
    if( noSearchParam === -1 ) {
        url = url.replace(/\?/, '') // 如果已经没有参数，删除？号
    }
    return url
}

/* 判断是否是移动端
* */
export function ismobile () {
    let u = navigator.userAgent
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    let isAndroid = u.match(/(Android)\s+([\d.]+)/)
    return isiOS||isAndroid
}
/* 深度克隆对象
* @param {object} obj - 目标对象
* */
export function deepClone (obj) {
    let newObj
    const isArr = Array.isArray(obj)
    const isObj = Object.prototype.toString.call(obj) === '[object Object]'
    if (isArr) {
        newObj = []
        let i = obj.length
        while (i--) {
            newObj[i] = deepClone(obj[i])
        }
        return newObj
    } else if (isObj) {
        newObj = {}
        for (let k in obj) {
            if (obj.hasOwnProperty(k)) {
                newObj[k] = deepClone(obj[k])
            }
        }
        return newObj
    }
    return obj
}

/**
 * 根据文件名获取文件扩展名
 * @param { String } filename
 * @returns { String }
 */
export function getFileExtension (filename) {
    if (typeof filename === 'string') {
        const arr = filename.split('.')
        if (arr.length === 1) {
            return ''
        }
        return arr.pop()
    }
    return ''
}

export function getKeyByValue (object, value) {
    return Object.keys(object).find(key => object[key] === value)
}

export function inObjectValues (object, value) {
    return Object.values(object).includes(value)
}

export function paging (list, page, pageSize) {
    const startIndex = page * pageSize
    const endIndex = startIndex + pageSize
    return list.slice(startIndex, endIndex)
}

// https://stackoverflow.com/a/3540295
export function isMobile () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|harmony/i.test(navigator.userAgent)
}

export function isDesktop () {
    return !isMobile()
}

// https://stackoverflow.com/a/9039885
export function isIos () {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}

/**
 * 在移动端中，不是 iOS 则认为是 android
 * @returns { Boolean }
 */
export function isAndroid () {
    return isMobile() && !isIos()
}

export function isWechat () {
    return /MicroMessenger/i.test(navigator.userAgent)
}

/**
 * 判断是否是 IE（不含 Edge）
 * from: https://stackoverflow.com/a/49986758
 */
export function isIENotIncludeEdge () {
    let ua = window.navigator.userAgent
    let msie = ua.indexOf('MSIE ') // IE 10 or older
    let trident = ua.indexOf('Trident/') //IE 11

    return (msie > 0 || trident > 0)
}

/**
 * 模拟推算文本宽度
 * @param { String } text - 文本
 * @param { Number } fontSize - 字体大小
 * @returns { Number }
 */
export function getTextWidth (text, fontSize) {
    text = String(text)
    text = text.split('')
    let width = 0
    text.forEach(function (item) {
        if (/[a-zA-Z]/.test(item)) {
            width += 7
        } else if (/[0-9]/.test(item)) {
            width += 5.5
        } else if (/\./.test(item)) {
            width += 2.7
        } else if (/-/.test(item)) {
            width += 3.25
        } else if (/[\u4e00-\u9fa5]/.test(item)) {  // 中文匹配
            width += 10
        } else if (/\(|\)/.test(item)) {
            width += 3.73
        } else if (/\s/.test(item)) {
            width += 2.5
        } else if (/%/.test(item)) {
            width += 8
        } else {
            width += 10
        }
    })
    return width * fontSize / 10
}

/**
 * 与当前时间相比，至 unit 级别是否相同
 * @param { Number } timestamp
 * @param { String } [unit=date] - 单位参考 https://github.com/iamkun/dayjs/blob/dev/docs/zh-cn/API-reference.md#%E5%8F%AF%E7%94%A8%E5%8D%95%E4%BD%8D
 * @returns { Boolean }
 */
export function isSameDate (timestamp, unit = 'date') {
    return dayjs().isSame(dayjs(timestamp), unit)
}

/**
 * 获取当前时间的时间戳
 * @returns { Number } 时间戳 ms
 */
export function nowTimestamp () {
    return new Date().valueOf()
}

/**
 * 将字节转为更常见的单位
 * @param { Number } bytes - 字节数
 * @param { Number } [decimals=2] - 小数位数
 * @returns { String }
 */
// https://stackoverflow.com/a/18650828
export function formatBytes (bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

/**
 * 获取数值区间所有整数
 * @param { Number } size - 数组大小
 * @param { Number } [startAt=0] - 起始值
 * @returns { Number[] }
 */
export function intRange (size, startAt = 0) {
    return [...Array(size).keys()].map(i => i + startAt)
}

/**
 * 和 Array.prototype.findIndex 参数一致，从右往左搜索，适用于消息列表
 * @param { Array } arr
 * @param { Function } predicate
 * @returns { Number }
 */
export function findLastIndex (arr, predicate) {
    let i = arr.length
    while (i--) {
        if (predicate(arr[i], i, arr)) {
            return i
        }
    }
    return -1
}

// https://stackoverflow.com/a/46181
export function isEmail (value) {
    // eslint-disable-next-line no-useless-escape
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(String(value).toLowerCase())
}

export function isPhoneNumber (value) {
    // const regex = /^1(3|4|5|6|7|8|9)\d{9}$/
    const regex = pattern('mobile')
    return value.length === 11 && regex.test(value)
}

// 格式化时间 mm:ss
export function time2Ms (time) {
    let m = parseInt(time / 60)
    let s = parseInt(time % 60)
    m = m < 10 ? '0' + m : m
    s = s < 10 ? '0' + s : s
    return `${m}:${s}`
}

/**
* 是否为 iPhone X or iPhoneXS or iPhoneXR or iPhoneXS Max or iPhone12 or iPhone12 proMax
* @returns {boolean}
*/
export function isIPhoneX () {
    return (
        typeof window !== undefined &&
        window.screen &&
        window.screen.width &&
        window.screen.height &&
        ((parseInt(window.screen.width, 10) === 375 && parseInt(window.screen.height, 10) === 812) ||
        (parseInt(window.screen.width, 10) === 390 && parseInt(window.screen.height, 10) === 844) || // iphone12
        (parseInt(window.screen.width, 10) === 414 && parseInt(window.screen.height, 10) === 896) ||
        (parseInt(window.screen.width, 10) === 428 && parseInt(window.screen.height, 10) === 926)) // iphone12 pro max
    )
}
